import styled from "styled-components";

export const Wrapper = styled.div`
  .marketplace-expiry-subtext {
    font-size: 12px;
    color: var(--app-text-muted);
  }

  .marketplace-mobile-credential-card {
    background: var(--app-surface);
    border-color: var(--app-border) !important;
  }

  .marketplace-mobile-value {
    color: var(--app-text);
  }

  .marketplace-empty-state {
    min-height: 250px;
    background: linear-gradient(
      180deg,
      color-mix(in srgb, #f45b68 6%, var(--app-surface)) 0%,
      var(--app-surface) 100%
    );
    border-radius: 24px;
    border: 1px solid var(--app-border);
  }

  .marketplace-empty-icon-wrap {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(244, 91, 104, 0.15), rgba(244, 91, 104, 0.05));
    border: 1px solid rgba(244, 91, 104, 0.2);
    box-shadow: 0 10px 35px rgba(244, 91, 104, 0.15);
  }

  .marketplace-empty-icon-ring {
    position: absolute;
    inset: -8px;
    border-radius: 50%;
    border: 2px dashed rgba(255, 153, 0, 0.25);
    animation: marketplaceSpinSlow 14s linear infinite;
  }

  .marketplace-empty-icon {
    font-size: 38px;
    color: var(--app-text);
    z-index: 2;
  }

  .marketplace-empty-logo {
    width: 50px;
    filter: brightness(1) grayscale(1);
    z-index: 2;
  }

  .marketplace-empty-title {
    color: var(--app-text);
    letter-spacing: -0.5px;
  }

  .marketplace-empty-desc {
    max-width: 700px;
    color: var(--app-text-muted);
    line-height: 1.7;
    font-size: 14px;
  }

  .marketplace-connect-btn {
    color: #fff;
    font-weight: 700;
    padding: 14px 28px;
    font-size: 15px;
    box-shadow: 0 12px 30px rgba(244, 91, 104, 0.25);
    transition: all 0.25s ease;
  }

  .marketplace-modal-secondary-btn {
    background: var(--app-surface-alt);
    border-color: var(--app-border);
    color: var(--app-text);
    transition: background 0.15s, color 0.15s, border-color 0.15s;
  }

  .marketplace-modal-secondary-btn:hover,
  .marketplace-modal-secondary-btn:focus {
    color: #f45b68;
    border-color: #f45b68;
    background: color-mix(in srgb, #f45b68 10%, var(--app-surface));
  }

  @keyframes marketplaceSpinSlow {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  [data-bs-theme="dark"] & .marketplace-empty-state {
    background: linear-gradient(180deg, rgba(244, 91, 104, 0.12) 0%, var(--app-surface) 100%);
  }
`;